export function AdditionalTypeReducer(state = [], action) {
    switch (action.type) {
        case "GET_ADDITIONAL_TYPES":
            return action.payload.result;
        case "ADD_ADDITIONAL_TO_LIST":
            return [];
        default:
            return state;
    }
}

export function AdditionalStyleReducer(state = [], action) {
    switch (action.type) {
        case "GET_ADDITIONAL_STYLES":
            return action.payload.result;
        case "ADD_ADDITIONAL_TO_LIST":
            return [];
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/additional_reducer.js